import React from 'react'
import '../../styles/footer.css'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa'
import { BsTwitter } from 'react-icons/bs'

const Footer = () => {
  return (
    <div className='footer-main-container'>
      <div className='footer-container'>
        <div className='top-footer'>
          <section>
            <div className='footer-logo'>
              <img
                src='https://media.istockphoto.com/id/1088853426/vector/wireframe-letter-d-outline-bevelled-3d-alphabet-design.jpg?s=612x612&w=is&k=20&c=CMWcbZpZJsvCwqeOgrp7nlufr3v5kw8BXdAV7Mo_koc='
                alt='Dynamind logo'
              />
              <h1>Dynamind</h1>
            </div>
            <div className='social-handle-container'>
              <div className='social-handle'>
                <FaFacebookF />
              </div>
              <div className='social-handle'>
                <BsTwitter />
              </div>
              <div className='social-handle'>
                <FaLinkedinIn />
              </div>
            </div>
          </section>
          <section>
            <ul>
              <li className='active'>Quick links</li>
              <li>
                <a href='/'>Home</a>
              </li>
              <li>
                <a href='/'>Features</a>
              </li>
              <li>
                <a href='/'>Services</a>
              </li>
              <li>
                <a href='/'>About</a>
              </li>
              <li>
                <a href='/'>Testimonials</a>
              </li>
            </ul>
          </section>
          <section>
            <ul>
              <li className='active'>Company</li>
              <li>
                <a href='/'>Features</a>
              </li>
              <li>
                <a href='/'>API DOCS</a>
              </li>
              <li>
                <a href='/'>API status</a>
              </li>
              <li>
                <a href='/'>Teachers</a>
              </li>
              <li>
                <a href='/'>Students</a>
              </li>
            </ul>
          </section>
          <section>
            <ul>
              <li className='active'>Others</li>
              <li>
                <a href='/'>Assesment</a>
              </li>
              <li>
                <a href='/'>Helpline</a>
              </li>
              <li>
                <a href='/'>Contact</a>
              </li>
            </ul>
          </section>
        </div>
        <div className='bottom-footer'>
          <section className='copyright-sec'>
            &copy;2021.<span>DYNAMIND</span>. All rights reserved
          </section>
          <section className='terms-sec'>
            Terms and conditions <span>|</span> Privacy policy
          </section>
        </div>
      </div>
    </div>
  )
}

export default Footer
